module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3c.6a43427e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-3c.svg
// module id = 550
// module chunks = 0